import Axios from "axios";

export default function ViewProcessedCategoryPriority(counsellingYear,selectedRound,selectedType,selectedEntrance){
    console.log(counsellingYear,selectedRound,selectedType,selectedEntrance);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a:'viewProcessedCategoryPriority',
            counsellingYear,
            selectedRound,
            selectedType,
            selectedEntrance                     
        }
    });
    return response;
}